import { render, staticRenderFns } from "./modalEditQuizQuestion.vue?vue&type=template&id=101f210c&scoped=true&"
import script from "./modalEditQuizQuestion.vue?vue&type=script&lang=js&"
export * from "./modalEditQuizQuestion.vue?vue&type=script&lang=js&"
import style0 from "./modalEditQuizQuestion.vue?vue&type=style&index=0&id=101f210c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101f210c",
  null
  
)

export default component.exports